import {createActionRecordAction} from "@buildwithflux/core";
import {IDocumentData, LayoutRules} from "@buildwithflux/models";
import {AppThunkAction} from "storeTypes";

export const toggleNodeSpecificRule = createActionRecordAction(
    "toggleNodeSpecificRule",
    (ruleId: string, nodeId: string, toggleState: boolean, latestDocumentState: IDocumentData | null) => {
        const node = latestDocumentState!.pcbLayoutNodes[nodeId]!;
        const rule = Object.values(node.pcbNodeRuleSet).find((rule) => rule.uid === ruleId);
        if (!rule) throw new Error("Cannot find the rule to be toggled");

        const hasInheritedRules = LayoutRules[rule.key].allChildNodesWillInheritThisRule;
        const hasInheritedCalculations = LayoutRules[rule.key].affectsDescendantCalculations ?? false;
        const requiresDescendantRebake = LayoutRules[rule.key].requiresDescendantRebake ?? false;
        const requiresNetDescendantRebake = LayoutRules[rule.key].requiresNetDescendantRebake ?? false;
        return {
            payload: {
                nodeId,
                ruleId,
                toggleState,
                canUndo: true,
                updatesDocumentTimestamp: true,
                shouldGenerateActionRecord: true,
                hasInheritedRules,
                hasInheritedCalculations,
                requiresDescendantRebake,
                requiresNetDescendantRebake,
            },
        };
    },
    "toggles an object-specific layout rule",
);

export const toggleNodeSpecificRuleThunk = (
    ruleId: string,
    nodeId: string,
    toggleState: boolean,
): AppThunkAction<void> => {
    return (_dispatch, _getState, services) => {
        services.documentStore.getState().toggleNodeSpecificRule(ruleId, nodeId, toggleState);
    };
};
